/*!

 =========================================================
 * Vue Paper Dashboard - v1.0.1
 =========================================================

 * Product Page: http://www.creative-tim.com/product/paper-dashboard
 * Copyright 2023 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from "vue";
import App from "./App";
import router from "./router/index";

import vuetify from '@/plugins/vuetify'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import PaperDashboard from "./plugins/paperDashboard";
import "vue-notifyjs/themes/default.css";
import {Calendar, DatePicker} from 'v-calendar'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// import VCalendar from 'v-calendar';

import VueOrgTree from 'vue-org-tree';

import store from "./store";

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueOrgTree)

Vue.use(PaperDashboard);

Vue.component('v-calendar', Calendar)
Vue.component('v-date-picker', DatePicker)
Vue.prototype.$globalType = new Vue();
// Vue.use(VCalendar, {
//   componentPrefix: 'v'
// })


/* eslint-disable no-new */
new Vue({
  store,
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
